









































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import baseService from "@/service/baseService";
import { IndexBar, IndexAnchor, Cell, Search, Tab, Tabs } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import enumUtils from "@/utils/enumUtils";
import { ApplyArea, categoryMap, Categorys, ZoneType } from "@/model/Base";

@Component({
  name: "selectAirport",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
})
export default class extends Vue {
  //data
  searchCity: string = "";
  ZoneDatas: object[] = [];
  get Citys() {
    return this.currentCache.Sorts;
  }
  get indexList() {
    return this.currentCache.Sorts.map((o: any) => o.title);
  }
  get currentCache() {
    return this.applyArea == ApplyArea.Internal ? this.cacheData.Internal : this.cacheData.Overseas;
  }

  dataShare = dataShare;

  get isShowSearchPage() {
    return this.searchCity && this.searchCity != "";
  }
  applyArea: string | number = 1126;

  searchLists: object[] = [];
  get areas() {
    let areas = enumUtils.makeArray(Categorys.ApplyArea);
    _.forEach(areas, item => {
      if (item.value == 1126) {
        item.text = this.$root.$t("modules_selectcity_guonei");
      }
      if (item.value == 1127) {
        item.text = this.$root.$t("modules_selectcity_guoji");
      }
    });
    return areas;
  }

  get ServiceType() {
    return this.$route.query.ServiceType;
  }

  mounted() {
    // 从地址栏获取区域类型 转为数字类型
    this.applyArea = Number(this.$route.query.ApplyArea as string);
    this.getCityData();
  }

  getCityData(value?: string) {
    const data = { ZoneType: "1447", ZoneTypes: "", ZoneName: "", Props: "CountryID,CityCode,CityName,CitySpell,OrderBy,ZoneCode,ZoneName,ZoneSpell", PageSize: 10000 };
    baseService.getZoneList(data).then(res => {
      if (!res.isSucc || !res.result || !res.result.entities) {
        return;
      }
      let InternalHots: any[] = [];
      let InternalCitys: any[] = [];
      let InternalAirports: any[] = [];

      let OverseasHots: any[] = [];
      let OverseasCitys: any[] = [];
      let OverseasAirports: any[] = [];

      const entities = res.result.entities.filter((item: any) => item.CityCode && item.CityName);
      let cityMap: any = {};
      entities.forEach((item: any) => {
        // let zoneType = categoryMap[item.ZoneType];
        // item.type = (zoneType && zoneType.CategoryTitle) || "";
        if (!item.CitySpell) {
          item.CitySpell = item.CityCode;
        }
        const list = {
          value: item.CityCode,
          label: item.ZoneName,
          type: "机场",
          CitySpell: item.CitySpell,
          OrderBy: item.OrderBy,
          CountryID: item.CountryID,
          ZoneCode: item.ZoneCode,
          ZoneType: ZoneType.Airport,
        };
        let city = cityMap[item.CityCode];
        let isNewCity = !city;
        if (isNewCity) {
          city = {
            value: item.CityCode,
            label: item.CityName,
            type: "城市",
            CitySpell: item.ZoneSpell,
            OrderBy: item.OrderBy,
            CountryID: item.CountryID,
            ZoneCode: item.ZoneCode,
            ZoneType: ZoneType.City,
          };
          cityMap[item.CityCode] = city;
        }

        if (list.CountryID == 151) {
          if (isNewCity) {
            InternalCitys.push(city);
            if (list.OrderBy) {
              InternalHots.push(city);
            }
          }
          InternalAirports.push(list);
        } else if (list.CountryID != 151) {
          if (isNewCity) {
            OverseasCitys.push(city);
            if (list.OrderBy) {
              OverseasHots.push(city);
            }
          }
          OverseasAirports.push(list);
        }
      });
      this.ZoneDatas = entities;
      this.cacheData.Internal.Hots = InternalHots as any;
      this.cacheData.Internal.Citys = InternalCitys as any;
      this.cacheData.Internal.Airports = InternalAirports as any;

      this.cacheData.Overseas.Hots = OverseasHots as any;
      this.cacheData.Overseas.Citys = OverseasCitys as any;
      this.cacheData.Overseas.Airports = OverseasAirports as any;

      this.handleZoneDatas(this.cacheData.Internal);
      this.handleZoneDatas(this.cacheData.Overseas);
    });
  }
  cacheData = {
    Internal: {
      Hots: [],
      Citys: [],
      Sorts: [],
      Airports: [],
    },
    Overseas: {
      Hots: [],
      Citys: [],
      Sorts: [],
      Airports: [],
    },
  };
  //对所有城市数据做处理
  handleZoneDatas(cacheCitys: any) {
    const allCitys: object[] = cacheCitys.Citys;
    let hotCitys: any[] = cacheCitys.Hots;
    let hotCity = { title: this.$root.$t("modules_selectcity_remen") as string, cities: hotCitys };

    hotCity.cities = _.orderBy(hotCitys, o => o.OrderBy, "asc");
    // 添加大阪
    const city = _.find(hotCitys, item => item.value === 'OSA');
    if(city) hotCity.cities.splice(2, 0, city);
    //按照A-Z分类
    const cityIndexList = _.groupBy(allCitys, (item: any) => _.upperFirst(item.CitySpell).slice(0, 1));
    const citySortList = this.getKeys(cityIndexList);
    citySortList.sort((a: any, b: any) => a.title.charCodeAt(0) - b.title.charCodeAt(0));
    let cityList = _.concat([hotCity], citySortList);
    cacheCitys.Sorts = cityList as any;
  }

  //按照key排序
  getKeys(value: any) {
    const lists: object[] = [];
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        lists.push({ title: key, cities: value[key] });
      }
    }
    return lists;
  }
  chooseCity(city: any) {
    this.currentCache.Sorts = [];
    (this as any).dataShare.City = city;
    this.back();
  }

  cancel() {
    this.searchCity = "";
  }

  back() {
    this.currentCache.Sorts = [];
    history.back();
  }

  changeTabs(){
    const searchCity = this.searchCity;
    if(!searchCity) return;
    let where = (el: any) =>
      (el.label && el.label.indexOf(searchCity) >= 0) ||
      (el.value && el.value.indexOf(searchCity) >= 0) ||
      (el.CitySpell && el.CitySpell.indexOf(searchCity) >= 0) ||
      (el.ZoneSpell && el.ZoneSpell.indexOf(searchCity) >= 0);

    let citys = this.currentCache.Citys.filter(where);
    let airports = this.currentCache.Airports.filter(where);
    let searchLists = citys.concat(airports);

    this.searchLists = _.uniq(searchLists);
  }

  @Watch("searchCity", { deep: true })
  handleWatch(newVal: string, oldVal: string) {
    if (newVal == "") {
      return;
    }
    let where = (el: any) =>
      (el.label && el.label.indexOf(newVal) >= 0) ||
      (el.value && el.value.indexOf(newVal) >= 0) ||
      (el.CitySpell && el.CitySpell.indexOf(newVal) >= 0) ||
      (el.ZoneSpell && el.ZoneSpell.indexOf(newVal) >= 0);

    let citys = this.currentCache.Citys.filter(where);
    let airports = this.currentCache.Airports.filter(where);
    let searchLists = citys.concat(airports);

    this.searchLists = _.uniq(searchLists);
  }
}
